
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import locale from 'element-ui/lib/locale/lang/en'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import VueAlert from '@vuejs-pt/vue-alert'
import VueAnalytics from 'vue-analytics'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueVideoPlayer from 'vue-video-player'
import VueDataTables from 'vue-data-tables'
import VueLazyLoad from 'vue-lazyload'
import VueProgressBar from 'vue-progressbar'
import VueZoomer from 'vue-zoomer'
import AsyncComputed from 'vue-async-computed'
import VuePaginateScroll from 'vue-paginate-scroll'
import Photoswipe from 'vue-pswipe'

// eslint-disable-next-line
import 'video.js/dist/video-js.css'
import Icon from 'vue-awesome/components/Icon'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import * as log from 'loglevel'

import store from './store'
import App from './components/App'
import router from './router'
import apollo from './graphql'

Vue.config.productionTip = false

Vue.use(VueZoomer)
Vue.use(ElementUI, { locale })
Vue.use(VueAlert)
Vue.use(Photoswipe)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAPS_API_KEY,
    libraries: 'geometry,places,visualization,weather',
  },
})
Vue.use(VueVideoPlayer)
Vue.use(VueDataTables)
Vue.use(AsyncComputed)

Vue.use(VueLazyLoad, {
  lazyComponent: true,
})

Vue.use(VueAnalytics, {
  id: 'UA-122298665-4',
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production',
  },
  router,
})

Vue.use(VueProgressBar, {
  color: '#074db6',
  failedColor: 'red',
  height: '10px',
})

if (process.env.NODE_ENV === 'production') {
  Raven.config('https://004f5418c84847558f1a4a539751b78b@sentry.getpopspots.com/2', {
    release: COMMITHASH /* eslint-disable-line */,
  })
    .addPlugin(RavenVue, Vue)
    .install()
}

Vue.component('icon', Icon)
Vue.component('vue-paginate-scroll', VuePaginateScroll)

/**
 * Set up the log level
 * log.levels.
 *  SILENT 0
 *  TRACE 1
 *  DEBUG 2
 *  INFO 3
 *  WARN 4
 *  ERROR 5
*/

if (process.env.NODE_ENV === 'production') {
  log.setLevel(log.levels.SILENT)
} else if (process.env.NODE_ENV === 'development') {
  log.setLevel(log.levels.TRACE)
} else {
  log.setLevel(log.levels.DEBUG)
}

Vue.mixin({
  methods: {
    hasPermission(op) {
      return this.$store.getters['Auth/hasPermission'](op)
    },
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  apolloProvider: apollo,
  components: { App },
  store,
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/app.js